<template>
  <div v-if="transfers && transfers.length">
    <table-blue-summary :cashIn="cashIn" :cashOut="cashOut" />
    <table-blue :cols="cols">
      <tr v-for="(item, index) in transfers" :key="index" :class="index % 2 ? 'even' : 'odd'">
        <table-blue-label-date :timestamp="item.timestamp" />
        <table-blue-label-action :action="item.action" />
        <table-blue-label-amount :action="item.action" :amount="item.amount" />
        <table-blue-label-ip :ip="item.ip" />
      </tr>
    </table-blue>
    <table-blue-label-count :amount="transfers.length" />
  </div>
  <table-blue-no-result v-else />
</template>

<script>
import TableBlue from './TableBlue/TableBlue';
import TableBlueSummary from './TableBlue/TableBlueSummary';
import TableBlueLabelDate from './TableBlue/TableBlueLabelDate';
import TableBlueLabelAction from './TableBlue/TableBlueLabelAction';
import TableBlueLabelAmount from './TableBlue/TableBlueLabelAmount';
import TableBlueLabelCount from './TableBlue/TableBlueLabelCount';
import TableBlueLabelIp from './TableBlue/TableBlueLabelIp';
import TableBlueNoResult from './TableBlue/TableBlueNoResult';

export default {
  name: 'TableBluePlayerTransfers',
  props: ['cashIn', 'cashOut', 'transfers'],
  components: {
    TableBlue,
    TableBlueSummary,
    TableBlueLabelDate,
    TableBlueLabelAction,
    TableBlueLabelAmount,
    TableBlueLabelCount,
    TableBlueLabelIp,
    TableBlueNoResult,
  },
  data() {
    return {
      cols: [
        { i18n: 'th.date',        align: 'center' },
        { i18n: 'th.action',      align: 'center' },
        { i18n: 'th.amount',      align: 'right' },
        { i18n: 'th.ip',          align: 'center', },
      ]
    }
  }
}
</script>
